__turbopack_context__.v({
  "code": "IRHxzG_code",
  "message": "IRHxzG_message",
  "notFound": "IRHxzG_notFound",
  "ring": "IRHxzG_ring",
});
